import React, { Component, FunctionComponent, ReactNode } from 'react';

import { SelectableGroupContext } from './SelectableGroup.context';

// tslint:disable-next-line: interface-name
interface TSelectAllProps {
  children: ReactNode;
  component?: string | FunctionComponent;
  className?: string;
  [key: string]: any;
}

export class SelectAll extends Component<TSelectAllProps> {
  public static contextType = SelectableGroupContext;

  public root: HTMLDivElement | null = null;

  public componentDidMount() {
    this.root!.addEventListener('mousedown', (evt: Event) => evt.stopPropagation());
  }

  public getRootRef = (ref: HTMLDivElement | null) => {
    this.root = ref;
  }

  public render() {
    const { component = 'div', children, className = '', ...rest } = this.props;
    const ButtonComponent = component as FunctionComponent<any>;

    return (
      <ButtonComponent
        ref={this.getRootRef}
        className={`selectable-select-all ${className}`}
        onClick={this.context.selectable.selectAll}
        {...rest}
      >
        {children}
      </ButtonComponent>
    );
  }
}
